import { PUBLIC_SWISH_BUNDLE_ID } from '$env/static/public';
import { env } from '$env/dynamic/public';

export const getHeaders = () => ({
  'x-swish-client-id': env.PUBLIC_SWISH_CLIENT_ID ?? '',
  'x-swish-client-secret': env.PUBLIC_SWISH_CLIENT_SECRET ?? '',
  'x-swish-bundle-id': PUBLIC_SWISH_BUNDLE_ID,
  'Content-Type': 'application/json'
});
